<!-- PDS Modal for MTO and Preorder Slot -->
<!-- TODO: isPreorderEnabled will be removed once the appropriate styles for new PDS classes are available -->
<ng-container *ngIf="modalData && (modalData.type === 'mto' || modalData.type === 'preorder_slot')">
    <div class="modal fade" [id]="modalData.modalId" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-modal="true"
        (keydown)="onKeydownModalEvent($event, modalData.modalId)" [attr.aria-label]="modalData.type === 'mto' ? (reservedTimeIntent | titlecase) + ' time will change' : 'Please pickup a new ' + modalData?.preference + ' time'"
     >
        
        <div class="modal-dialog pds-modal-size__small pds-modal-dialog" aria-hidden="false">
            <div class="modal-content pds-modal-content" aria-hidden="false" data-qa="cart-slot-modal">
                <!-- Modal Content here -->
                <ng-container *ngTemplateOutlet="modalData.type === 'mto' ? mto : preorder_slot"></ng-container>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #mto>
    <div
        class="modal-header pds-modal-header pds-modal-header--small border-bottom-0 d-flex flex-column pb-1">
        <!-- Modal header here -->
        <button
            class="pds-close pds-icon-btn pds-icon-btn-size_small pds-icon-btn-transparent--neutral d-flex align-items-center justify-content-center ml-auto"
            aria-label="Close" data-dismiss="modal">
            <span class="pds-svg-close pds-icon-btn-transparent--neutral__icon"
                aria-hidden="true"></span>
        </button>
        <div class="pds-modal-header__box d-flex flex-column align-items-center" >
            <h2 id="mto-modal-label" class="modal-title heading-s flex-grow-1" data-qa="mto-ttl">{{ reservedTimeIntent | titlecase }} time will change</h2>
        </div>
    </div>
    <div class="modal-body pds-modal-body--small text-l pt-3 pb-3 text-center" data-qa="mto-txt">
        <!-- Modal Body here -->
        This item requires {{ product?.mtoDisplyableTime }} to prepare. Please select a new time for {{ reservedTimeIntent | titlecase }}.
    </div>
    <!-- Modal Footer here (Action Group) -->
    <div class="modal-footer pds-modal-footer pds-modal-footer--small border-top-0">
        <div
            class="pds-modal-footer__button-box align-items-center d-flex flex-column">
            <button
                class="pds-btn pds-btn-size__medium pds-btn-filled--primary d-flex align-items-center justify-content-center"
                aria-label="Reserve new time" data-dismiss="modal" (click)="handleSlotAction('reserve-new-time',modalData.modalId); analyticsEvents('modalClick', 'reserve-new-time')" data-qa="mto-rsrv-btn">Reserve new time</button>
            <button
                class="pds-btn pds-btn-size__medium pds-btn-outlined--primary d-flex align-items-center justify-content-center"
                aria-label="Choose time later" data-dismiss="modal" (click)="handleSlotAction('choose-time-later',modalData.modalId);analyticsEvents('modalClick', 'choose-time-later')" data-qa="mto-chs-tm-btn">Choose time later</button>
            <button
                class="pds-btn pds-btn-size__medium pds-btn-transparent--primary d-flex align-items-center justify-content-center" 
                data-dismiss="modal" data-qa="mto-dnt-add-btn" aria-label="Don't add item" (click)="handleClose();analyticsEvents('modalClick', 'dont-add-item')">Don't add item</button>
        </div>
    </div>
</ng-template>

<!-- MTO MODAL End-->

<!-- Previous Customizations Modal Start-->

<ng-container *ngIf="modalData && modalData.type === 'product_customization_modal' && !isDigitalDeliPdsModalEnabled">
    <div class="modal fade product-customization-modal" 
    [id]="modalData.modalId"
    role="dialog" 
    aria-hidden="true" 
    aria-modal="true"
    aria-label="Add with your previous customization."
    tabindex="-1" 
    (keydown)="onKeydownModalEvent($event, modalData.modalId)"
>
        <div class="modal-dialog modal-dialog-centered notif-modal">
            <div class="modal-content">
                <div class="modal-header product-customization-modal__header">
                    <button class="close product-customization-modal__header__modal-close"
                        data-dismiss="modal"
                        aria-label="Add with your previous customizations?  Close"
                        (click)="handleClose()"
                        >
                        <span
                            class="svg-icon svg-close-primary product-customization-modal__header__close-icon"
                            aria-hidden="true"></span>
                    </button>
                </div>
                <div class="modal-body notif-styles ">
                    <ng-container *ngTemplateOutlet="product_customization_modal"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #product_customization_modal>
    <div class="notif-styles__content">
        <div class="d-flex justify-content-center">
            <img class="notif-styles__img" loading="lazy"
                [src]="'https://images.albertsons-media.com/is/image/ABS/' + customizationData?.bpn + '?$ecom-product-card-mobile-jpg$&defaultImage=Not_Available'"
                [alt]="customizationData?.name">
        </div>
        <h1 class="heading-s notif-styles__content--title">
            Add with your previous customizations?
        </h1>
        <ng-container *ngIf="customizationData">
            <ng-container *ngFor="let item of customizationData.items">
                <ul class="list-unstyled m-0 p-0 text-left text-l">
                    <li *ngFor="let customization of item?.customizations">
                        {{ customization.type }}:
                        <span *ngFor="let option of customization?.options; let last = last">
                            <span [ngClass]="{'text-l--error': !option.channelInventory || option.channelInventory[reservedTimeIntent] !== '1'}">
                                <span [attr.aria-hidden]="isCateringEnabled && option.quantity > 1 ? 'true' : null">{{ option.name }}&nbsp;</span>
                                <span *ngIf="isCateringEnabled && option.quantity > 1" [ngClass]="{'text-l--error': !option.channelInventory || option.channelInventory[reservedTimeIntent] !== '1'}" aria-hidden="true">({{ option.quantity }})</span>
                                <span *ngIf="isCateringEnabled && option.quantity > 1" class="sr-only">{{ option.quantity }} units of {{ option.name }}</span>
                            </span>
                            <span *ngIf="isCateringEnabled && option.price > 0" [ngClass]="{'text-l--error': !option.channelInventory || option.channelInventory[reservedTimeIntent] !== '1'}">
                                <span aria-hidden="true">(+{{ (option.price * option.quantity) | currency: 'USD'}})</span>
                                <span class="sr-only"> {{ (option.price * option.quantity) | currency: 'USD' }} more for each topping </span>
                            </span>
                            <span *ngIf="!option.channelInventory || option.channelInventory[reservedTimeIntent] !== '1'">
                                <span class="text-l-b--error"> Out of stock</span>
                            </span>
                            <ng-container *ngIf="!last || (last && item.preferences)">, </ng-container>
                        </span>
                    </li>
                    <li *ngIf="item.preferences">
                        Preferences: <span>{{item.preferences}}</span>
                    </li>
                </ul>
            </ng-container>
        </ng-container>
        
        <button
            class="pds-btn pds-btn-size__medium pds-btn-filled--primary d-flex align-items-center justify-content-center mt-2"
            aria-label="Add my previous customizations"
            (click) = "handleAddItemFromPreviousCustomization()"
            [disabled]="isRequiredIngredientOutOfStock">
            Add
        </button>
        <a role="link" class="link-sm links__action underline d-flex justify-content-center"
            (click)="handleModifyPreviousCustomization()" 
            aria-label="Modify previous customizations"  href="javascript:void(0);"
        >Modify</a>
    </div>
</ng-template>

<!-- Previous Customizations Modal End-->


<!-- Previous Customizations Error Modal Start-->

<ng-container *ngIf="modalData && modalData.type === 'previous_customizations_error' && !isDigitalDeliPdsModalEnabled">
    <div 
      class="modal fade product-customization-modal" 
      [id]="modalData.modalId" 
      role="dialog"
      aria-modal="true"
      aria-label="Unable to load"
      tabindex="-1" 
     (keydown) = "onKeydownModalEvent($event, modalData.modalId)"
    >
      <div class="modal-dialog modal-dialog-centered notif-modal">
        <div class="modal-content">
          <div class="modal-header product-customization-modal__header">
            <button 
              class="close product-customization-modal__header__modal-close"
              data-dismiss="modal" 
              aria-label="Close previous customization"
              (click)="handleClose()"
            >
              <span
                class="svg-icon svg-close-primary product-customization-modal__header__close-icon"
                aria-hidden="true"
              ></span>
            </button>
          </div>
          <div class="modal-body notif-styles">
            <ng-container *ngTemplateOutlet="previous_customizations_error"></ng-container>
          </div>
        </div>
      </div>
    </div>
</ng-container>

<ng-template #previous_customizations_error>
    <div class="notif-styles__content notif-styles__content--error">
        <div class="d-flex justify-content-center" aria-hidden="true">
          <span class="svg-error-broken-wifi notif-styles__content--icon mr-0">
          </span>
        </div>
        <div class="d-flex flex-column align-items-center notif-styles__content--error">
            <div class="d-flex flex-column align-items-center notif-styles__content">
                <div role="heading" [id]="modalData.modalId" aria-level="2" class="heading-s m-0" >Unable to load</div>
                <div class="text-l mx-4 text-center">
                    Sorry, we weren't able to load your previous customizations. Please refresh,
                    or customize again.
                  </div>
                <div class="w-100 btn-container">
                    <button
                        [ngStyle]="modalData.isLoading ? { 'pointer-events': 'none' } : {}"
                        class="pds-btn pds-btn-size__medium pds-btn-filled--primary d-flex align-items-center justify-content-center"
                        (click)="handleRefresh()" 
                        aria-label="Refresh"
                        >
                        <ng-container *ngIf="!modalData.isLoading; else showLoading">
                            Refresh
                        </ng-container>
                        <ng-template #showLoading>
                            <div class="pp-loading-spinner" aria-live="assertive" role="alert" aria-label="Loading"></div>
                        </ng-template> 
                    </button>
                </div>
            </div>
                <a role="link" class="link-sm links__action underline d-flex justify-content-center mt-1"
                (click)="startCustmization()" 
                aria-label="Start a new customization"  href="javascript:void(0);"
                >Start a new customization</a>
        </div>
      </div>
</ng-template>

<!-- Previous Customizations Error Modal End-->

<!-- FLAG - isDigitalDeliPdsModalEnabled -->
<!-- Previous Customizations Modal Start-->

<ng-container *ngIf="modalData && modalData.type === 'product_customization_modal' && isDigitalDeliPdsModalEnabled">
    <div class="modal fade product-customization-modal" 
        [id]="modalData.modalId"
        role="dialog" 
        aria-hidden="true" 
        aria-modal="true"
        aria-label="Add with your previous customization."
        tabindex="-1" 
        (keydown)="onKeydownModalEvent($event, modalData.modalId)"
    >
        <div class="modal-dialog pds-modal-size__medium pds-modal-dialog">
            <div class="modal-content pds-modal-content">
                <div class="modal-header pds-modal-header pds-modal-header--small border-bottom-0 d-flex flex-column pb-0">
                    <button class="pds-modal-header__close-btn pds-icon-btn pds-icon-btn-size_small pds-icon-btn-transparent--neutral d-flex align-items-center justify-content-center ml-auto"
                        data-dismiss="modal"
                        aria-label="Add with your previous customizations?  Close"
                        (click)="handleClose()"
                        >
                        <span
                            class="pds-svg-close pds-icon-btn-transparent--neutral__icon"
                            aria-hidden="true"></span>
                    </button>
                </div>
                <div class="modal-body pds-modal-body--small text-l pt-3 pb-3">
                    <ng-container *ngTemplateOutlet="product_customization_modal_new"></ng-container>
                </div>
                <div class="modal-footer pds-modal-footer pds-modal-footer--small border-top-0">
                    <div class="pds-modal-footer__button-box align-items-center d-flex">
                        <button class="pds-btn pds-btn-size__medium pds-btn-outlined--primary d-flex align-items-center justify-content-center" (click)="handleModifyPreviousCustomization()" aria-label="Modify previous customizations">
                            Modify
                        </button>
                        <button
                            class="pds-btn pds-btn-size__medium pds-btn-filled--primary d-flex align-items-center justify-content-center"
                            aria-label="Add my previous customizations"
                            (click) = "handleAddItemFromPreviousCustomization()"
                            [disabled]="isRequiredIngredientOutOfStock">
                            Add
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #product_customization_modal_new>
    <div class="px-4">
        <div class="d-flex justify-content-center mb-3">
            <img class="image-container-pds-square" loading="lazy"
                [src]="'https://images.albertsons-media.com/is/image/ABS/' + customizationData?.bpn + '?$ecom-product-card-mobile-jpg$&defaultImage=Not_Available'"
                [alt]="customizationData?.name">
        </div>
        <div class="d-flex flex-column align-items-center text-center">
            <h3 class="modal-title heading-s flex-grow-1">Add with your previous customizations?</h3>
        </div>
        <hr>
        <ng-container *ngIf="customizationData">
            <ng-container *ngFor="let item of customizationData.items">
                <ul class="list-unstyled m-0 p-0 text-left text-l">
                    <li *ngFor="let customization of item?.customizations" class="text-l--medium">
                        {{ customization.type }}:
                        <span *ngFor="let option of customization?.options; let last = last" class="text-l-sb">
                            <span [ngClass]="{'text-l--error': !option.channelInventory || option.channelInventory[reservedTimeIntent] !== '1'}">
                                <span [attr.aria-hidden]="isCateringEnabled && option.quantity > 1 ? 'true' : null">{{ option.name }}&nbsp;</span>
                                <span *ngIf="isCateringEnabled && option.quantity > 1" [ngClass]="{'text-l--error': !option.channelInventory || option.channelInventory[reservedTimeIntent] !== '1'}" aria-hidden="true">({{ option.quantity }})</span>
                                <span *ngIf="isCateringEnabled && option.quantity > 1" class="sr-only">{{ option.quantity }} units of {{ option.name }}</span>
                            </span>
                            <span *ngIf="isCateringEnabled && option?.price > 0" [ngClass]="{'text-l--error': !option.channelInventory || option.channelInventory[reservedTimeIntent] !== '1'}">
                                <span aria-hidden="true">(+{{ (option?.quantity > 0 ? option?.price * option?.quantity : option?.price) | currency: 'USD'}})</span>
                                <span class="sr-only"> {{ (option?.quantity > 0 ? option?.price * option?.quantity : option?.price) | currency: 'USD' }} more for each topping </span>
                            </span>
                            <span *ngIf="!option.channelInventory || option.channelInventory[reservedTimeIntent] !== '1'">
                                <span class="text-l-b--error"> Out of stock</span>
                            </span>
                            <ng-container *ngIf="!last && customization?.options?.length > 1">, </ng-container>
                        </span>
                    </li>
                    <li *ngIf="item.preferences" class="text-l--medium">
                        Preferences: <span class="text-l-sb">{{item.preferences}}</span>
                    </li>
                </ul>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<!-- Previous Customizations Modal End-->

<!-- Previous Customizations Error Modal Start with flag-->

<ng-container *ngIf="modalData && modalData.type === 'previous_customizations_error' && isDigitalDeliPdsModalEnabled">
    <div 
        class="modal fade product-customization-modal" 
        [id]="modalData.modalId" 
        role="dialog"
        aria-modal="true"
        aria-label="Unable to load"
        tabindex="-1" 
        (keydown) = "onKeydownModalEvent($event, modalData.modalId)"
    >
        <div class="modal-dialog pds-modal-size__medium pds-modal-dialog">
            <div class="modal-content pds-modal-content">
                <div class="modal-header pds-modal-header pds-modal-header--small border-bottom-0 d-flex flex-column pb-1">
                    <button 
                    class="pds-modal-header__close-btn pds-icon-btn pds-icon-btn-size_small pds-icon-btn-transparent--neutral d-flex align-items-center justify-content-center ml-auto"
                    data-dismiss="modal" 
                    aria-label="Close previous customization"
                    (click)="handleClose()"
                    >
                    <span
                        class="pds-svg-close pds-icon-btn-transparent--neutral__icon"
                        aria-hidden="true"
                    ></span>
                    </button>
                </div>
                <div class="modal-body pds-modal-body--small text-l pt-3 pb-3">
                    <ng-container *ngTemplateOutlet="previous_customizations_error_new"></ng-container>
                </div>
                <!-- Modal Footer here (Action Group) -->
                <div class="modal-footer pds-modal-footer pds-modal-footer--small border-top-0">
                    <div class="pds-modal-footer__button-box align-items-center d-flex flex-column">
                        <button
                            [ngStyle]="modalData.isLoading ? { 'pointer-events': 'none' } : {}"
                            class="pds-btn pds-btn-size__medium pds-btn-filled--primary d-flex align-items-center justify-content-center"
                            (click)="handleRefresh()"
                            aria-label="Refresh"
                            >
                            <ng-container *ngIf="!modalData.isLoading; else showLoading">
                                Refresh
                            </ng-container>
                            <ng-template #showLoading>
                                <div class="pp-loading-spinner" aria-live="assertive" role="alert" aria-label="Loading"></div>
                            </ng-template>
                        </button>
                        <button class="pds-btn link-m--primary pds-modal-footer__link"
                            role="link"
                            (click)="startCustmization()"
                            aria-label="Start a new customization"
                            >Start a new customization
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #previous_customizations_error_new>
    <div>
        <div class="d-flex justify-content-center" aria-hidden="true">
          <span class="svg-error-broken-wifi notif-styles__content--icon mr-0"></span>
        </div>
        <div>
            <div class="d-flex flex-column align-items-center notif-styles__content mt-3 text-center">
                <h3 class="heading-s" [id]="modalData.modalId">Unable to load</h3>
                <div class="text-l mt-1 text-center">
                    Sorry, we weren't able to load your previous customizations. Please refresh,
                    or customize again.
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- Previous Customizations Error Modal End-->
<!-- FLAG - isDigitalDeliPdsModalEnabled End-->

<!-- PreBook Modal Start-->
<ng-container *ngIf="modalData && modalData.type === 'prebook_modal'">
    <div class="modal fade prebook-modal" tabindex="-1" [id]="modalData.modalId" role="dialog" aria-label="This item isn't available."
    tabindex="-1" (keydown) = "onKeydownModalEvent($event, modalData.modalId)">
    <div class="modal-dialog modal-dialog-centered notif-modal" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button class="close" data-dismiss="modal"
                    aria-label="Close Customization" 
                    (click)="handleClose()"
                    >
                    <span class="svg-icon svg-close-primary"></span>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="prebook_modal"></ng-container>
        </div>
    </div>
    </div>
</ng-container>

<!-- PreBook Slot Drawer template-->
<ng-container *ngIf="modalData && modalData.type === 'prebook_slot_drawer'">
    <div class="rd__cont--prebook pt-4 prebook-slot-drawer">
        <div class="rd__cont--prebook__body d-flex flex-column">
            <div class="d-flex">
                <button class="btn btn-sm pds-btn-transparent--primary back"
                    aria-label="This item isnt available..., Back to Customization" (click)="previousPageAction()">
                    <span aria-hidden="true" class="svg-caret-left"></span>
                    <span class="text-l-sb">Back</span>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="prebook_modal"></ng-container>
        </div>
    </div>
</ng-container>

<ng-template #prebook_modal>
    <div class="d-flex flex-column align-items-center"  
    [ngClass]="modalData.type === 'prebook_slot_drawer' ? 'rd__cont--prebook__body__content' : 'pt-1 prebook-modal__container'">
        <div class="d-flex flex-column align-items-center text-center"
        [ngClass]="modalData.type === 'prebook_slot_drawer' ? 'rd__cont--prebook__body__text-container' : 'prebook-modal__content'">
            <div class="heading-s" [ngClass]="modalData.type === 'prebook_slot_drawer' ? 'mb-0' : 'mb-2'" role="heading" aria-level="2">This item isn't available during the time you picked.</div>
            <div class="text-l" [ngClass]="modalData.type === 'prebook_modal' ? 'mb-4' : ''" data-qa="pdp_dd_pbs_mdl_sbttl" *ngIf="modalData.isAvaialableTime">
                <span class="sr-only">Made to order deli items are available only from {{modalData.preBookShortTime}}.</span>
                <span aria-hidden="true">Made to order deli items are available only from
                    {{modalData.preBookLongTime}}.</span>
            </div>
            <div class="text-l" [ngClass]="modalData.type === 'prebook_modal' ? 'mb-4' : ''" data-qa="pdp_dd_pbs_mdl_sbttl" *ngIf="modalData.isMoreTimePrepare">This item requires more
                time to prepare.</div>
        </div>
        <div
            class="d-flex flex-column align-items-center" [ngClass]="{'prebook-modal__content prebook-modal__content--btn-container': modalData.type !== 'prebook_slot_drawer', 'rd__cont--prebook__body__btn-container w-100': modalData.type === 'prebook_slot_drawer'}">
            <button
                class="pds-btn pds-btn-size__medium pds-btn-filled--primary d-flex align-items-center justify-content-center"
                data-qa="pdp_dd_pbs_mdl_prmry_bttn" (click) = "handleAddAnywayAction(modalData.type)" aria-label="Got It add anyways">Got it, add anyways</button>
<button
                class="pds-btn pds-btn-size__medium pds-btn-outlined--primary d-flex align-items-center justify-content-center" (click)="handleAddAndUpdateItem(modalData.type)" aria-label="Add Item & Update Item link">Add
item & update time</button>
        </div>
    </div>
</ng-template>

<!-- PreBook Modal End-->

<!-- Preorder Modal Start -->
<ng-container *ngIf="modalData && modalData.type === 'preorder'">
    <div class="modal fade" tabindex="-1" [id]="modalData.modalId" role="dialog" aria-label="Heads Up: This is a preorder item"  data-backdrop="static" data-keyboard="false" (keydown)="onKeydownModalEvent($event, modalData.modalId)" aria-modal="true">
        <div class="modal-dialog pds-modal-size__small pds-modal-dialog" aria-hidden="false">
            <div class="modal-content pds-modal-content" aria-hidden="false">
                <!-- Modal Content here -->
                <div
                    class="modal-header pds-modal-header pds-modal-header--small border-bottom-0 d-flex flex-column pb-1">
                    <!-- Modal header here -->
                    <button
                        aria-hidden="false"
                        class="pds-close pds-icon-btn pds-icon-btn-size_small pds-icon-btn-transparent--neutral d-flex align-items-center justify-content-center ml-auto"
                        aria-label="Close" data-dismiss="modal" data-qa="preorder-close" (click)="handleClose()">
                        <span class="pds-svg-close pds-icon-btn-transparent--neutral__icon"
                            aria-hidden="true"></span>
                    </button>
                    <div class="pds-modal-header__box d-flex flex-column align-items-center text-center">
                        <div aria-hidden="true">
                            <!-- TODO: Replace with SVG icon/Img -->
                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="96" height="115" viewBox="0 0 96 115" fill="none">
                                <path d="M26.9676 19.4089C27.2139 17.8171 32.3698 4.19624 32.4281 2.30938C32.4863 0.422528 26.0243 6.89862 26.4256 18.8624C26.2047 20.0241 26.9676 19.4089 26.9676 19.4089Z" fill="#C0EBAB"/>
                                <path d="M28.8132 22.0254C27.8745 20.2252 22.9909 2.48237 21.6254 0.56736C20.2599 -1.34765 18.5186 10.0193 27.8243 21.874C28.4851 23.2247 28.8132 22.0254 28.8132 22.0254Z" fill="#A3D48A"/>
                                <path d="M26.4931 22.4681C26.5892 20.6306 24.4336 4.13277 24.7862 2.05816C25.1387 -0.0164538 30.073 8.7158 27.1482 21.996C27.1069 23.3417 26.4931 22.4681 26.4931 22.4681Z" fill="#6EB749"/>
                                <path d="M25.0004 26.7241C25.663 25.0093 34.361 10.8518 34.8867 8.81552C35.4124 6.77926 27.353 12.716 24.5964 26.0247C24.0847 27.2687 25.0004 26.7241 25.0004 26.7241Z" fill="#A3D48A"/>
                                <path d="M24.129 48.577C22.9177 44.7355 21.9522 41.6807 21.051 37.274C19.8374 31.3465 19.5672 27.0251 20.8892 22.7844C21.2705 21.5643 21.7805 20.3566 22.8785 19.3354C24.8779 17.4791 28.2218 16.7969 30.7604 18.0563C32.1951 18.7683 33.0433 19.9363 33.6326 20.9758C36.0657 25.2645 35.6186 30.0478 35.2655 34.1767C33.966 49.3288 33.3161 56.9033 33.5918 59.2803C33.7828 60.9272 34.3022 64.616 33.3758 64.9365C32.7727 65.1459 31.8039 63.8355 31.152 62.9027C26.6742 56.4864 24.4185 49.4945 24.129 48.577Z" fill="#F59F49"/>
                                <path d="M13.411 27.8316C13.0361 26.2616 12.7764 11.6887 12.106 9.9151C11.4356 8.14146 7.68003 16.5686 12.6763 27.5266C12.9101 28.6878 13.411 27.8316 13.411 27.8316Z" fill="#6EB749"/>
                                <path d="M14.1618 28.4724C12.7925 26.9514 3.58948 10.8819 1.77226 9.35452C-0.0449545 7.82711 1.06504 19.3244 13.1524 28.5691C14.1371 29.7211 14.1618 28.4724 14.1618 28.4724Z" fill="#6EB749"/>
                                <path d="M13.9447 29.817C13.3425 28.0704 5.0873 13.5169 4.63775 11.4537C4.1882 9.39049 12.1375 15.6759 14.3849 29.1326C14.8533 30.4009 13.9447 29.817 13.9447 29.817Z" fill="#A3D48A"/>
                                <path d="M16.0702 55.4683C13.9791 52.1387 12.081 48.6944 10.3852 45.152C7.80178 39.6535 6.52074 35.4998 6.83574 31.0513C6.86557 29.6961 7.26542 28.374 7.993 27.2249C8.80607 26.0526 9.94557 25.1383 11.2735 24.5928C12.6015 24.0473 14.0609 23.8941 15.4751 24.1515C16.8449 24.5104 18.0711 25.2744 18.9894 26.3411C22.3954 29.9625 23.0765 34.7336 23.6904 38.8517C25.955 53.9363 27.0873 61.4787 27.9116 63.7319C28.4855 65.3009 29.8618 68.7745 29.0231 69.3042C28.4834 69.6447 27.2493 68.5604 26.3398 67.8314C22.3477 64.2061 18.8907 60.0444 16.0702 55.4683Z" fill="#F26A50"/>
                                <path d="M52.3062 32.8978C52.7546 28.7388 55.938 26.3435 56.8509 25.6557C59.1499 23.9253 59.8082 24.8023 62.8216 22.6661C65.0674 21.0743 65.5619 19.9773 67.8137 19.1144C69.0036 18.6584 70.7177 18.0015 72.0042 18.7916C73.5739 19.7557 73.5887 22.3064 73.5971 23.9076C73.6078 25.6932 73.2447 26.5099 72.7235 29.0145C71.8503 33.2109 72.3571 33.3651 71.7966 35.2209C71.4802 36.2672 69.7968 41.2537 64.9365 42.8605C64.5513 42.9881 59.4958 44.5626 55.5137 41.1163C53.0198 38.9576 51.9995 35.7392 52.3062 32.8978Z" fill="#294D17"/>
                                <path d="M27.2649 48.745C26.8888 48.8003 26.5142 48.7112 26.2164 48.4958C25.9538 48.317 25.7578 48.0566 25.6551 47.7506C28.1336 45.3186 30.0905 42.4011 31.3884 39.201C30.3791 39.0414 29.4807 38.5199 28.8541 37.73C28.334 37.0499 28.0463 36.2099 28.0304 35.3259C28.0145 34.442 28.2716 33.5579 28.7659 32.796C29.3275 32.0055 30.1243 31.4128 31.0287 31.1138C30.5728 30.2115 30.3613 29.1914 30.4144 28.1511C30.4683 27.2468 30.7315 26.3551 31.1822 25.5474C31.6328 24.7397 32.2586 24.0389 33.0091 23.5014C33.9194 22.9402 34.9599 22.6613 35.9931 22.7018C36.2012 17.6552 42.1284 16.1229 42.7603 18.0923C43.718 16.3266 46.3988 14.827 48.3415 15.9545C51.5827 17.8358 48.6307 21.3349 48.5087 21.4888C49.2551 22.0111 49.7924 22.7813 50.0354 23.6778C50.3011 24.8161 50.1051 26.0426 49.4906 27.0914C48.963 27.9996 48.1808 28.7379 47.2505 29.2058C47.8121 30.1743 48.0531 31.3135 47.9406 32.4674C47.9047 33.1404 47.7249 33.8064 47.4141 34.4199C47.1034 35.0333 46.6691 35.5794 46.1405 36.0206C45.6357 36.3823 45.0693 36.6411 44.4763 36.781C43.8834 36.9208 43.2758 36.9389 42.6906 36.8342C42.7298 37.6191 42.5893 38.4141 42.2795 39.1571C41.9697 39.9001 41.4991 40.5714 40.9042 41.1194C40.3094 41.6673 39.6058 42.0769 38.8485 42.3169C38.0911 42.5569 37.3002 42.6209 36.5364 42.5034C35.156 42.341 33.9137 41.668 33.0446 40.6117C31.373 43.4904 29.4374 46.2144 27.2649 48.745Z" fill="#6EB749"/>
                                <path d="M42.4861 22.9816C41.4527 24.284 40.5737 25.3315 39.9725 26.0161C39.6544 25.4542 39.3819 24.8653 39.1573 24.2548C38.6882 22.9342 38.6422 22.0689 38.5174 22.0863C38.2431 23.1815 38.2118 24.3097 38.426 25.3881C38.5369 26.2981 38.7562 27.1846 39.0791 28.0287C38.4068 29.1362 37.607 30.2894 36.8655 31.4168C36.5575 30.5459 36.0512 29.7705 35.3857 29.1503C34.638 28.4768 33.6683 28.004 33.529 28.1628C33.3898 28.3217 34.0657 28.8786 34.631 29.8056C35.2203 30.7948 35.583 31.9147 35.6939 33.0884L30.8452 41.8519C32.5024 40.0308 34.0517 38.1139 35.4852 36.1126C36.6032 34.5298 37.5802 33.0147 38.4303 31.5909C39.9735 31.4646 41.4956 31.0293 42.9066 30.3097C43.9522 29.7632 45.0551 28.9803 44.9707 28.7666C44.8863 28.5528 43.7966 28.9837 41.7497 29.3685C40.8212 29.5336 40.0583 29.6152 39.5552 29.6677C40.2276 28.5602 40.9843 27.5016 41.7094 26.4247C42.4664 26.2727 43.204 26.0094 43.8977 25.6428C45.0461 25.0212 46.2981 24.0401 46.1379 23.6925C45.9776 23.345 45.4006 23.5194 42.8024 24.4829C44.979 20.4741 45.3391 19.5747 45.2547 19.5257C44.2649 20.6225 43.3404 21.7769 42.4861 22.9816Z" fill="#A3D48A"/>
                                <path d="M34.7587 39.7781C34.7264 39.6121 34.7409 39.4395 34.8006 39.2808C34.8604 39.122 34.9631 38.9842 35.0959 38.8832C37.6383 38.3149 40.1072 37.4282 42.4485 36.2432C46.2784 34.3194 49.7138 31.6394 52.5594 28.3558C51.5645 27.8529 50.7242 27.0768 50.1298 26.111C49.4938 25.0981 49.2111 23.8883 49.3273 22.6791C49.4435 21.4698 49.9522 20.3324 50.77 19.453C51.4165 18.7424 52.2273 18.2146 53.1241 17.92C52.6393 17.6021 52.2469 17.154 51.9889 16.623C51.7309 16.092 51.6165 15.4975 51.6574 14.9017C51.7124 14.4019 51.8774 13.9203 52.1397 13.4946C52.402 13.0688 52.7545 12.7102 53.1702 12.4459C53.5781 12.195 54.0303 12.0324 54.4992 11.9683C54.968 11.9042 55.4438 11.94 55.8967 12.0732C55.6535 11.4353 55.5506 10.7481 55.5953 10.0609C55.64 9.37367 55.8311 8.7034 56.1551 8.09871C56.4792 7.49402 56.9283 6.97002 57.4696 6.56388C58.0108 6.15773 58.6311 5.87961 59.2856 5.74993C59.937 5.60045 60.6089 5.58758 61.2624 5.71202C61.6938 5.80592 62.0834 6.04144 62.373 6.38353C62.6626 6.72562 62.8369 7.15599 62.8706 7.61152C62.9176 8.29225 62.9469 9.09354 62.9269 9.97413C62.5957 24.0066 50.0685 33.3194 48.4379 34.4926C44.467 37.3365 39.9966 39.3388 35.288 40.3822C35.1598 40.332 35.0448 40.2512 34.953 40.1463C34.8611 40.0414 34.7945 39.9151 34.7587 39.7781Z" fill="#A3D48A"/>
                                <path d="M55.2272 26.6062C54.3446 25.3479 51.8726 25.0915 50.2511 25.4953C48.0508 26.0452 46.2384 28.1024 47.0847 29.6012C47.878 31.0042 50.8003 31.5525 52.7737 30.8713C54.8026 30.1689 56.2252 28.028 55.2272 26.6062Z" fill="#F59F49"/>
                                <path d="M43.9561 24.8183L41.0692 37.5779C41.0356 37.7266 41.129 37.8735 41.2779 37.9062L66.9961 43.5463C67.1449 43.579 67.2929 43.4849 67.3265 43.3363L70.1525 30.8458C70.1861 30.6972 70.0927 30.5502 69.9439 30.5176L54.3848 27.1053C54.4173 28.1665 53.9158 29.3106 53.0013 29.8572C51.5988 30.6937 49.8566 29.7479 49.3758 28.2583C49.1543 27.5693 49.1942 26.7308 49.4958 26.0332L43.9561 24.8183Z" fill="#F7CC4A"/>
                                <path d="M70.1997 30.1792L43.7242 24.7601C45.006 24.5417 46.4485 24.3728 48.0265 24.3144C49.3253 24.2686 50.5288 24.3027 51.6165 24.3861C57.8109 26.3171 64.0053 28.2482 70.1997 30.1792Z" fill="#F59F49"/>
                                <path d="M63.6148 32.447C63.2093 31.5823 61.9212 31.5045 61.0529 31.8676C59.8743 32.3588 58.8331 33.9134 59.2092 34.9494C59.5642 35.9196 61.0699 36.1839 62.137 35.6116C63.2309 35.0198 64.072 33.42 63.6148 32.447Z" fill="#F59F49"/>
                                <path d="M62.4814 38.7943C62.8565 39.0744 63.5245 38.8535 63.8932 38.5318C64.394 38.0957 64.6165 37.2441 64.2227 36.8869C63.8524 36.5529 63.0376 36.7389 62.6092 37.1869C62.1711 37.6481 62.0588 38.4792 62.4814 38.7943Z" fill="#F59F49"/>
                                <path d="M47.1134 32.6382C46.8815 31.9828 46.0628 31.9629 45.4982 32.2705C44.7317 32.6868 44.0202 33.9204 44.228 34.7091C44.4245 35.4476 45.3761 35.6048 46.074 35.1293C46.7894 34.638 47.3749 33.3757 47.1134 32.6382Z" fill="#F59F49"/>
                                <path d="M4.74902 33.7952C4.74902 34.183 5.13133 106.248 5.13133 106.248C5.13133 106.248 61.9221 107.991 62.2112 107.894C62.5004 107.797 74.7325 104.184 74.7325 104.184L72.3917 33.2752L68.0567 36.5216L63.8777 33.0225L59.9077 36.8919L56.7466 34.292L54.1568 36.9064L50.5104 34.3908C50.5104 34.3908 48.3056 37.0052 48.0164 36.9064C47.7272 36.8077 44.8511 34.1976 44.8511 34.1976L42.4487 36.9064L39.1874 34.1061L36.7894 36.9064L33.0471 34.1061L30.2711 36.7206L27.2002 34.2048L24.3226 36.8193L21.1558 33.5294L18.5673 36.6159L16.4571 33.817L14.4413 37.0125L11.276 33.817L8.5415 37.6385L4.74902 33.7952Z" fill="#FABB7D"/>
                                <path d="M63.8807 33.0225C63.6674 33.8489 62.4619 107.855 62.4619 107.855L69.6445 96.9334L68.3002 36.4838L63.8807 33.0225Z" fill="#F59F49"/>
                                <path d="M72.3913 33.2751C72.6089 34.1031 74.8179 104.011 74.8179 104.011L69.5652 97.8033L67.9131 36.5926L72.3913 33.2751Z" fill="#F59F49"/>
                                <path d="M62.4619 107.853C62.6752 107.545 69.6517 96.9319 69.6517 96.9319L74.9846 104.146L62.4619 107.853Z" fill="#F59F49"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0601 42.2012L22.3491 42.4319L21.5945 56.8705H44.7307L44.9438 43.0493L49.2383 43.1175L49.0051 58.2349C48.9993 59.0266 48.6868 59.7845 48.1347 60.3447C47.5775 60.91 46.8216 61.2279 46.033 61.2279H20.1971C19.7963 61.2276 19.4 61.145 19.0319 60.9854C18.6634 60.8257 18.3307 60.5921 18.0538 60.2989C17.7765 60.0053 17.5608 59.6581 17.4193 59.2782C17.2778 58.8981 17.2134 58.493 17.2301 58.0869L17.2306 58.0746L18.0601 42.2012Z" fill="#F59F49"/>
                                <path d="M48.5931 101.854L61.5117 80.5428C64.6612 75.3471 72.2153 75.3915 75.3036 80.6238L87.8822 101.935C91.044 107.292 87.1823 114.055 80.962 114.055H55.4648C49.2024 114.055 45.3468 107.209 48.5931 101.854Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M63.9861 83.2523C66.2661 79.3228 71.9662 79.3228 74.2462 83.2523L85.5905 102.803C87.8705 106.733 85.0205 111.644 80.4604 111.644H57.7719C53.2118 111.644 50.3618 106.733 52.6418 102.803L63.9861 83.2523Z" fill="#C63939"/>
                                <path d="M68.3555 88.2406C68.5999 87.9554 68.911 87.8127 69.2887 87.8127C69.6664 87.8127 69.9886 87.9554 70.2552 88.2406C70.4996 88.5259 70.6218 88.8586 70.6218 89.239V98.9848C70.6218 99.3651 70.4996 99.6979 70.2552 99.9831C69.9886 100.268 69.6664 100.411 69.2887 100.411C68.911 100.411 68.5999 100.268 68.3555 99.9831C68.0889 99.6979 67.9556 99.3651 67.9556 98.9848V89.239C67.9556 88.8586 68.0889 88.5259 68.3555 88.2406ZM68.3555 102.96C68.5999 102.699 68.911 102.568 69.2887 102.568C69.6664 102.568 69.9886 102.699 70.2552 102.96C70.4996 103.246 70.6218 103.59 70.6218 103.994V104.957C70.6218 105.337 70.4996 105.67 70.2552 105.955C69.9886 106.241 69.6664 106.383 69.2887 106.383C68.911 106.383 68.5999 106.241 68.3555 105.955C68.0889 105.67 67.9556 105.337 67.9556 104.957V103.994C67.9556 103.59 68.0889 103.246 68.3555 102.96Z" fill="white"/>
                            </svg>
                        </div>
                        <div id="preorder-modal-label" role = "heading" aria-level="2" class="modal-title heading-s text-center flex-grow-1 pt-3">Heads Up: This is a preorder item</div>
                    </div>
                </div>
                <div class="modal-body pds-modal-body--small text-l text-center pt-3 pb-3" id="preorder-modal-description">
                    <!-- Modal Body here -->
                    <span>Your order will be completed after this item releases on 
                        <span aria-hidden="true">{{ modalData.itemEffectiveStartDate | date:'EEE, MMM d' }}</span>
                        <span class="sr-only">{{ modalData.itemEffectiveStartDate | date:'EEEE, MMMM d' }}</span>. Do you want to continue adding this item?
                    </span>
                </div>
                <!-- Modal Footer here (Action Group) -->
                <div class="modal-footer pds-modal-footer pds-modal-footer--small border-top-0">
                    <div class="pds-modal-footer__button-box align-items-center d-flex flex-column">
                        <button
                            class="pds-btn pds-btn-size__medium pds-btn-filled--primary d-flex align-items-center justify-content-center"
                            data-qa="preorder-continue-btn" (click)="handlePreorderItem()">
                            Continue</button>
                        <button class="pds-btn link-m--primary" data-dismiss="modal" (click)="handleClose()"
                            data-qa="dont-add-item-btn">Don't add item</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<!-- Preorder Modal End -->

<ng-template #preorder_slot>
    <div
        class="modal-header pds-modal-header pds-modal-header--small border-bottom-0 d-flex flex-column pb-1">
        <!-- Modal header here -->
        <button
            class="pds-close pds-icon-btn pds-icon-btn-size_small pds-icon-btn-transparent--neutral d-flex align-items-center justify-content-center ml-auto"
            aria-label="Close" data-dismiss="modal" aria-hidden="false" (click)="handleClose()" data-qa="cart-slot-close">
            <span class="pds-svg-close pds-icon-btn-transparent--neutral__icon"
                aria-hidden="true"></span>
        </button>
        <div class="pds-modal-header__box d-flex flex-column align-items-center text-center">
            <div role = "heading" aria-level="2" id="preorder_slot-modal-label" class="modal-title heading-s flex-grow-1">Please pick a new {{modalData?.preference}} time.</div>
        </div>
    </div>
    <div id="preorder_slot-modal-description" class="modal-body pds-modal-body--small text-l pb-0 text-center">
        <!-- Modal Body here -->
        This preorder item hasn’t been released yet.
    </div> 
   <!--  Modal Footer here (Action Group) -->
    <div class="modal-footer pds-modal-footer pds-modal-footer--small border-top-0">
        <div
            class="pds-modal-footer__button-box align-items-center d-flex flex-column">
            <button
                class="pds-btn pds-btn-size__medium pds-btn-filled--primary"
                 (click)="handleSlotAction('reserve-new-time',modalData.modalId)" data-qa="cart-slot-rsrv-btn">Reserve new time</button>
            <button
                class="pds-btn pds-btn-size__medium pds-btn-outlined--primary"
                 (click)="handleSlotAction('choose-time-later',modalData.modalId)" data-qa="cart-slot-chs-tm-btn">Choose time later</button>
            <button class="pds-btn link-m--primary"
                data-dismiss="modal" data-qa="cart-slot-dnt-add-btn" (click)="handleClose()" >Don't add item</button>
        </div>
    </div>
</ng-template>
